<template>
  <div class="p-3" style="font-family: IRANSansX-Regular">
    <div class="row justify-content-center" style="direction: ltr">
      <div class="col-12 col-md-6 m-md-0 order-1">
        <div class="input-group mr-auto mx-auto text-center p-2 location-detail mt-2">
          <div
            style="font-size: 14px; text-align: center; width: 100%; color: #6e6e6e"
            class="mb-2"
          >
            زمان
          </div>
          <div class="input-group">
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="ساعت"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="دقیقه"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="ثانیه"
            />
          </div>
          <div class="input-group">
            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_hour" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_min" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_sec" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 m-md-0 order-2">
        <div class="input-group mr-auto mx-auto text-center p-2 location-detail mt-2">
          <div
            style="font-size: 14px; text-align: center; width: 100%; color: #6e6e6e"
            class="mb-2"
          >
            تاریخ
          </div>
          <div class="input-group">
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="سال"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="ماه"
              disabled
            />
            <input
              class="form-control"
              style="
                font-size: 12px;
                border: none;
                text-align: center;
                background: transparent;
              "
              type="text"
              value="روز"
            />
          </div>
          <div class="input-group">
            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_year" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_month" disabled />
              </div>
            </div>

            <div class="h-input-group">
              <div class="h-input-wrapper">
                <input class="h-input" type="text" v-model="now_day" disabled />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 m-3"></div>
    <input class="autocomplete-input" v-model="selectedLocation" disabled />
    <!-- <div
      class="w-100 p-2 text-right text-md-center text-secondary mt-2"
      dir="rtl"
      style="font-size: 14px"
    >
      موقعیت جغرافیایی پیشفرض در قسمت تنظیمات قابل تغییر است.
    </div> -->
    <div style="width: 300px" class="mr-auto mx-auto"></div>

    <!-- <div class="advanced-area" style="direction: ltr" v-if="is_advance_form"> -->
    <div class="advanced-area" style="direction: ltr">
      <div class="row mt-3">
        <div class="col-12 col-md-6 m-md-0 mb-3">
          <DSTSelector @updateFormDSToffset="updateDSToffset"></DSTSelector>
        </div>

        <div class="col-12 col-md-6 m-md-0 mb-3">
          <TimezoneSelector
            :input_disabled="true"
            :default_input.sync="timezone"
          ></TimezoneSelector>
        </div>
      </div>
    </div>
    <div class="w-100 m-3"></div>

    <div class="w-100 m-3"></div>

    <div class="container text-center mb-2">
      <div @click="submitChart()" class="calculate-btn mr-auto mx-auto">محاسبه پرشنا</div>
    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import ApiService from "../service/api";
import DSTSelector from "./DSTSelector.vue";
import TimezoneSelector from "./TimezoneSelector.vue";

import HelperLib from "./helper";
import Loading from "./Loading.vue";

import moment from "jalali-moment";
export default {
  name: "ChartFormPrashnaPro",
  components: {
    Loading,
    DatePicker,
    Autocomplete,
    TimezoneSelector,
    DSTSelector,
    TimePicker,

  },
  props: {},
  data() {
    return {
      isLoading: false,
      now_year: null,
      now_month: null,
      now_day: null,
      now_hour: null,
      now_min: null,
      now_sec: null,
      now_timezone: null,
      timezone: null,
      country: null,
      city: null,
      state: null,
      selectedLocation: null,
      isloading: false,
      dst_hour: 0,
      dst_min: 0,
      longitude: 51.3896,
      latitude: 35.6893,
      datepicker_column: {
        576: 1, // under 576px, column count is 1
        992: 2, // under 992px, column count is 2
      },
      chart_result: [],
    };
  },
  created() {
    // Update the time every second
    // this.populateSettings();
    this.isLoading = true;

    ApiService.getSettings().then((response) => {
      this.longitude = response["data"]["settings"]["longitude"];
      this.latitude = response["data"]["settings"]["latitude"];
      this.country = response["data"]["settings"]["country"];
      this.city = response["data"]["settings"]["city"];
      this.state = response["data"]["settings"]["state"];
      this.selectedColor = response["data"]["settings"]["chart_bg"];
      this.selectedLocation = `${this.country} - ${this.state} - ${this.city}`;
      // console.log(response["data"]["tz"]);
      this.timezone = response["data"]["tz"][1];

      // this.handlerNearestTimezone();
      // console.log(this.now_timezone)
      // let now = null;

      // this.now_timezone = this.timezone;
      // console.log(this.timezone)
      const now = moment().utcOffset(this.timezone);
      // const timezoneOffset = now.format("Z");
      this.now_year = now.format("jYYYY");
      this.now_month = now.format("jMM");
      this.now_day = now.format("jDD");
      this.now_hour = now.format("HH");
      this.now_min = now.format("mm");
      this.now_sec = now.format("ss");
      // this.isLoading = false;

      const request = {
        year: this.now_year,
        month: this.now_month,
        day: this.now_day,
        hour: this.now_hour,
        min: this.now_min,
        sec: this.now_sec,
        timezone: this.timezone,
        dst_hour: this.dst_hour,
        dst_min: this.dst_min,
      };

      // this.isLoading = true;
      ApiService.getPrashna(request).then((response) => {
        // console.log(response)
        this.chart_result = response["data"];
        const now = moment().utcOffset(this.chart_result["user"]["timezone"]);
        if (this.chart_result["user"]["date_type"] == "jalali") {
          this.t_year = now.format("jYYYY");
          this.t_month = now.format("jMM");
          this.t_day = now.format("jDD");
          this.t_hour = now.format("HH");
          this.t_min = now.format("mm");
          this.t_sec = now.format("ss");
        } else {
          this.t_year = now.format("YYYY");
          this.t_month = now.format("MM");
          this.t_day = now.format("DD");
          this.t_hour = now.format("HH");
          this.t_min = now.format("mm");
          this.t_sec = now.format("ss");
        }

        // console.log(
        //   this.t_year,
        //   this.t_month,
        //   this.t_day,
        //   this.t_hour,
        //   this.t_min,
        //   this.t_sec
        // );

        // const id = this.chart_result["link"];
        // const request_t = {
        //   hash_id: id,
        //   t_year: this.t_year,
        //   t_month: this.t_month,
        //   t_day: this.t_day,
        //   t_hour: this.t_hour,
        //   t_min: this.t_min,
        //   t_sec: this.t_sec,
        // };
        // ApiService.getTransit(request_t).then((resp_t) => {
        //   // console.log(resp_t);
        //   this.isLoading = false;
        //   this.chart_result["varga"]["transit"] = resp_t["data"]["varga"]["transit"];
        //   this.$emit("appViewUpdateData", this.chart_result);
        //   // this.chart_result["display_bhavas"] = this.loadData["bhava"];
        // });
          this.$emit("appViewUpdateData", this.chart_result);
          setInterval(this.updateTime, 1000);
          this.isLoading = false;

        // this.submitChart();
      });

      // console.log(this.chart_result);
    });

  },
  mounted() {},
  watch: {},
  methods: {
    populateSettings() {
      this.isLoading = true;
      ApiService.getSettings().then((response) => {
        if (response["data"]["status"] == 1) {
          this.longitude = response["data"]["settings"]["longitude"];
          this.latitude = response["data"]["settings"]["latitude"];
          this.country = response["data"]["settings"]["country"];
          this.city = response["data"]["settings"]["city"];
          this.state = response["data"]["settings"]["state"];
          this.selectedColor = response["data"]["settings"]["chart_bg"];
          this.selectedLocation = `${this.country} - ${this.state} - ${this.city}`;
          // console.log(response["data"]["tz"]);
          this.timezone = response["data"]["tz"][1];
          // this.handlerNearestTimezone();
          this.isLoading = false;
        }
      });
    },
    handlerNearestTimezone() {
      let request = {
        latitude: this.latitude,
        longitude: this.longitude,
      };

      ApiService.getNearestTimezone(request).then((response) => {
        this.now_timezone = response["data"][1];
      });
    },
    updateTime() {
      // const tz = this.timezone ? this.timezone : this.now_timezone;
      const now = moment().utcOffset(this.timezone);
      // const timezoneOffset = now.format("Z");
      // const formattedTime = now.format("jYYYY-jMM-jDD HH:mm:ss");
      this.now_year = now.format("jYYYY");
      this.now_month = now.format("jMM");
      this.now_day = now.format("jDD");
      this.now_hour = now.format("HH");
      this.now_min = now.format("mm");
      this.now_sec = now.format("ss");
      // this.now_timezone = timezoneOffset;

      // this.currentTime = `${formattedTime} (${tz})`;
    },
    getRange(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i.toString());
      }
      return result;
    },
    updateDSToffset(dst_value) {
      if (dst_value == 0) {
        this.dst_hour = "0";
        this.dst_min = "0";
      }
      if (dst_value == 1) {
        this.dst_hour = "0";
        this.dst_min = "30";
      }
      if (dst_value == 2) {
        this.dst_hour = "1";
        this.dst_min = "0";
      }
      if (dst_value == 3) {
        this.dst_hour = "1";
        this.dst_min = "30";
      }
      if (dst_value == 4) {
        this.dst_hour = "2";
        this.dst_min = "0";
      }
    },
    validateForm() {
      let result = false;
      // console.log(this.chart_request.hour)
      if (this.chart_request.title === "") {
        this.errors.name_error = "block";
      }
      if (this.chart_request.title != "") {
        this.errors.name_error = "none";
      }
      // if (this.chart_request.gender === null) {
      //   this.errors.gender_error = "block";
      // }
      // if (this.chart_request.gender != null) {
      //   this.errors.gender_error = "none";
      // }
      if (this.chart_request.hour === null) {
        this.errors.time_error = "block";
      }
      if (this.chart_request.year === null) {
        this.errors.date_error = "block";
      }
      if (this.chart_request.longitude == null) {
        this.errors.location_error = "red";
      }
      if (this.chart_request.hour != null) {
        this.errors.time_error = "none";
      }
      if (this.chart_request.year != null) {
        this.errors.date_error = "none";
      }
      if (this.chart_request.longitude != null) {
        this.errors.location_error = "transparent";
      }
      if (
        this.chart_request.year != null &&
        this.chart_request.month != null &&
        this.chart_request.day != null &&
        this.chart_request.hour != null &&
        this.chart_request.longitude != null &&
        this.chart_request.title != ""
        // this.chart_request.gender != null
      ) {
        result = true;
      }
      // console.log(result)
      return result;
    },
    resetFormErrors() {},
    showFormErrors() {},
    submitChart() {
      const request = {
        year: this.now_year,
        month: this.now_month,
        day: this.now_day,
        hour: this.now_hour,
        min: this.now_min,
        sec: this.now_sec,
        timezone: this.timezone,
        dst_hour: this.dst_hour,
        dst_min: this.dst_min,
      };

      this.isLoading = true;
      ApiService.getPrashna(request).then((response) => {
        this.chart_result = response["data"];
        this.$emit("appViewUpdateData", this.chart_result);
        this.isLoading = false;
      });
      // }
    },
  },
};
</script>

<style scoped>

.h-input-group {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin: 5px;
  outline: none;
}
.h-input-wrapper {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: 100%;
  box-sizing: border-box;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.h-input {
  font-size: 1rem;
  background-size: 25px 25px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  color: #495057 !important;
  background-color: transparent;
  border-style: none;
  pointer-events: auto;
  flex: 1 1;
  margin-top: 0;
  min-width: 0;
  position: relative;
  line-height: 20px;
  max-width: 100%;
  width: 100%;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  text-align: center;
}

.h-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(128 189 255 / 50%);
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

</style>

<style scoped>


.chart-datepicker > input {
  background: #eee;
}


.calculate-btn {
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  padding-right: 20px;
  padding-left: 20px;
  width: fit-content;
  color: #fff;
  border: 1px #ccc solid;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #339966;
  outline: none;
  font-size: 16px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.calculate-btn:hover {
  transition: all 1s;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
}



.location-detail {
  text-align: center;
  border: none;
  border-radius: 8px;
  background-color: #eee;
  font-size: 16px;
  text-align: center;
  margin: 0px;
  height: auto;
}
</style>
